<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.acc-single-inv-report.edit.invoice'">
                <fui-rows>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-account-invoice-autocomplete-edit-control formControlName="RECEIPTNO"
                                                                               [(ngModel)]="model.data.RECEIPTNO"
                                                                               (onSelect)="populateAccountDetails($event)">
                                </wbo-account-invoice-autocomplete-edit-control>
                            </fui-column>
                            <fui-column>
                                <fui-tandem-field>
                                    <wbo-text-edit-control formControlName="ACCOUNTNO"
                                                           [(ngModel)]="model.data.ACCOUNTNO"
                                                           [readonly]="true"></wbo-text-edit-control>
                                    <wbo-text-edit-control formControlName="ACCOUNTNAME"
                                                           [(ngModel)]="model.data.ACCOUNTNAME"
                                                           [readonly]="true"></wbo-text-edit-control>
                                </fui-tandem-field>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-single-select-edit-control [formControlName]="'addressAccount'"
                                                                [(ngModel)]="model.data.addressAccount"
                                                                [allowClearSelectionOption]="false">
                                    <wbo-select-options>
                                        <wbo-select-option [value]="0"
                                                           label="wbo.acc-item-stmt-report.option.address.postal"></wbo-select-option>
                                        <wbo-select-option [value]="1"
                                                           label="wbo.acc-item-stmt-report.option.address.home"></wbo-select-option>
                                    </wbo-select-options>
                                </wbo-single-select-edit-control>
                            </fui-column>
                            <fui-column>
                                <wbo-checkbox-edit-control formControlName="SIGN4GOODS"
                                                           [(ngModel)]="model.data.SIGN4GOODS"></wbo-checkbox-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>

                </fui-rows>
            </fui-row>

            <fui-row [label]="'wbo.acc-single-inv-report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-checkbox-edit-control formControlName="COPYONLY"
                                                           [(ngModel)]="model.data.COPYONLY"></wbo-checkbox-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-checkbox-edit-control formControlName="specifyInvoicingDetails"
                                                           [(ngModel)]="model.data.specifyInvoicingDetails"></wbo-checkbox-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row
                        *ngIf="model.data.BILLINGCYCLE">
                        <fui-two-columns>
                            <fui-column>
                                <wbo-text-edit-control formControlName="BILLINGCYCLE"
                                                       [(ngModel)]="model.data.BILLINGCYCLE"
                                                       [readonly]="true"></wbo-text-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row
                        *ngIf="model.data.specifyInvoicingDetails || model.data.TERMS || (model.data.TERMSCOMMENT && model.data.TERMSCOMMENT.trim() != '') ">
                        <fui-two-columns>
                            <fui-column>
                                <wbo-numeric-edit-control formControlName="TERMS" [(ngModel)]="model.data.TERMS"
                                                          [notation]="'wbo.acc-single-inv-report.edit.field.TERMS.notation' | translate"
                                                          [readonly]="!(model.data.BILLINGCYCLE === 'none' && model.data.specifyInvoicingDetails)"></wbo-numeric-edit-control>
                            </fui-column>
                            <fui-column>
                                <wbo-text-edit-control formControlName="TERMSCOMMENT"
                                                       [(ngModel)]="model.data.TERMSCOMMENT"
                                                       [readonly]="!(model.data.BILLINGCYCLE === 'none' && model.data.specifyInvoicingDetails)"></wbo-text-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row
                        *ngIf="(model.data.BILLINGCYCLE === 'none' && model.data.specifyInvoicingDetails) || model.data.DUEDATE">
                        <fui-two-columns>
                            <fui-column>
                                <wbo-date-edit-control formControlName="DUEDATE"
                                                       [(ngModel)]="model.data.DUEDATE"
                                                       [readonly]="!(model.data.BILLINGCYCLE === 'none' && model.data.specifyInvoicingDetails)"></wbo-date-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row
                        *ngIf="model.data.specifyInvoicingDetails || (model.data.HEADER && model.data.HEADER.trim() != '')">
                        <fui-two-columns>
                            <fui-column>
                                <wbo-textarea-edit-control formControlName="HEADER"
                                                           [(ngModel)]="model.data.HEADER"
                                                           [readonly]="!model.data.specifyInvoicingDetails"></wbo-textarea-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row
                        *ngIf="model.data.specifyInvoicingDetails || (model.data.FOOTER && model.data.FOOTER.trim() != '') || (model.data.CREDITFOOTER && model.data.CREDITFOOTER.trim() != '')">
                        <fui-two-columns>
                            <fui-column>
                                <wbo-textarea-edit-control formControlName="FOOTER"
                                                           [(ngModel)]="model.data.FOOTER"
                                                           [readonly]="!model.data.specifyInvoicingDetails"></wbo-textarea-edit-control>
                            </fui-column>
                            <fui-column>
                                <wbo-textarea-edit-control formControlName="CREDITFOOTER"
                                                           [(ngModel)]="model.data.CREDITFOOTER"
                                                           [readonly]="!model.data.specifyInvoicingDetails"></wbo-textarea-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
